<template>
	<div class="learning-process">
		<speaker-notes :notes="notes"></speaker-notes>
		<h2>Getting Started</h2>
		<div class="quote">
		<blockquote>
			The Web Audio API can seem intimidating to those that aren't familiar with audio or music terms, and as it incorporates a great deal of functionality it can prove difficult to get started if you are a developer.
		</blockquote>
		<p class="author">- https://developer.mozilla.org/en-US/docs/<span class="right">Web/API/Web_Audio_API</span></p>
		</div>
	</div>
</template>

<script>
	import SpeakerNotes from "../components/SpeakerNotes";
	export default {
		name: "learning-process",
		components: {SpeakerNotes},
		data() {
			return {
				notes: [
					"This is the only thing that I'll quote out of the official documentation.",
					"This is an accurate statement.",
				]
			};
		},
	}
</script>

<style lang="scss" scoped>
	.learning-process {
		text-align: center;
	}
	.quote {
		display: inline-block;
		text-align: left;
	}
	.author {
		font-style: italic;
		margin-left: 40px;
	}
	blockquote {
		background: #f9f9f9;
		padding: 10px;
		max-width: 1000px;
		font-size: 1.4em;
	}
	blockquote:before {
		color: #ccc;
		content: "\201C";
		font-family: "Times New Roman", serif;
		font-size: 4em;
		line-height: 0.1em;
		margin-right: 0.25em;
		vertical-align: -0.4em;
	}
	blockquote:after {
		color: #ccc;
		content: "\201D";
		font-family: "Times New Roman", serif;
		font-size: 4em;
		line-height: 0.1em;
		margin-right: 0.25em;
		vertical-align: -0.4em;
	}
	.right {
		display: block;
		text-align: right;
	}
</style>
